import { render, staticRenderFns } from "./PriceCentre.vue?vue&type=template&id=67c68f0e&scoped=true&"
import script from "./PriceCentre.vue?vue&type=script&lang=js&"
export * from "./PriceCentre.vue?vue&type=script&lang=js&"
import style0 from "./PriceCentre.vue?vue&type=style&index=0&id=67c68f0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c68f0e",
  null
  
)

export default component.exports